import { render } from "./GroupEditModal.vue?vue&type=template&id=a8de394c&scoped=true"
import script from "./GroupEditModal.vue?vue&type=script&lang=js"
export * from "./GroupEditModal.vue?vue&type=script&lang=js"

import "./GroupEditModal.vue?vue&type=style&index=0&id=a8de394c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8de394c"]])

export default __exports__